// extracted by mini-css-extract-plugin
export default {"permission-picker__input":"PermissionPicker_permission-picker__input__aS8mE"};